import { useContext } from 'react';
import { PreferencesContext, PreferencesContextData } from './context';

export function usePreferences(): PreferencesContextData {
    const data = useContext<PreferencesContextData | undefined>(
        PreferencesContext
    );

    if (!data) {
        throw new Error(
            "Preferences unavailable. Are you sure you're using this in a nested component of an PreferencesProvider?"
        );
    }

    return data;
}
